module.exports = __webpack_public_path__ + "static/media/Jeida5.367debdd.jpg";